import axios, { AxiosResponse } from 'axios';
import { Cookies } from 'react-cookie';

const MapServiceTZ = (): any => {

    return {
        getMapData: (search: string): Promise<AxiosResponse<any, any>> => {
            const url = "/tz/mapData?search=" + search;
            return axios.get(process.env.REACT_APP_API_URL + url, { headers: { 'SID': new Cookies().get("user")?.token } });
        },
        getCoords: (): Promise<AxiosResponse<any, any>> => {
            const url = "/tz/coords";
            return axios.get(process.env.REACT_APP_API_URL + url, { headers: { 'SID': new Cookies().get("user")?.token } });
        },
        getSegments: (minCount: number, year: string): Promise<AxiosResponse<any, any>> => {
            const params = new URLSearchParams({ minCount: String(minCount) });
            if (year) params.append('year', year);
            const url = "/tz/segments?" + params.toString();
            return axios.get(process.env.REACT_APP_API_URL + url, { headers: { 'SID': new Cookies().get("user")?.token } });
        }
    };
}

export default MapServiceTZ();